import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function LTP({ symbol_id }) {
  const socket = useContext(SocketContext);

  const [ltp, setLtp] = useState(0);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.LTP !== undefined) {
        setLtp(data.LTP);
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return (
    <div className="menuLtp addFlex">
      <CheckValue number={ltp} change={1} extra={"AddFontSize"} />
    </div>
  );
}
